import { usePatchedNavigate } from "src/Hooks/usePatchedNavigate";
import { useQuery } from "src/Hooks/useReactQuery";
import { getFilesHistoryTestPackageDetail } from "src/services/test-packages";
import APP_ROUTES from "src/routes/routes";
import { FILE_HISTORY_TYPES } from "src/constant/common";

const useGetFilesHistoryTestPackageDetail = ({
  filesHistoryPage = 1,
  limit = 9999999,
  q,
  test_package_id,
  type = FILE_HISTORY_TYPES.DEPLOYMENT,
  key = "getFilesHistoryTestPackageDetail",
} = {}) => {
  const navigate = usePatchedNavigate();

  const queryFn = () => {
    const params = { page: filesHistoryPage, limit, ...(q && { q }), ...(test_package_id && { test_package_id }), ...(type && { type }) };
    return getFilesHistoryTestPackageDetail(params);
  };

  const { data, isLoading, isError, error, refetch, isFetching } = useQuery({
    queryKey: [key, filesHistoryPage, q, test_package_id],
    queryFn,
    onError: (error) => {
      if (error?.response?.status === 404) {
        navigate(APP_ROUTES.NOT_FOUND);
      }
    },
    refetchInterval: false,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    refetch,
    isLoading,
    isError,
    error,
    isFetching,
  };
};

export default useGetFilesHistoryTestPackageDetail;
